module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pager.pages && _vm.pager.pages.length > 1) ? _c('div', {
    staticClass: "w-full h-7"
  }, [_c('div', {
    staticClass: "flex float-left h-full items-center"
  }, [_c('span', {
    staticClass: "inline-block text-gray-400 text-xs"
  }, [_vm._v("\n      Showing " + _vm._s(_vm.pager.startIndex + 1) + "-" + _vm._s(_vm.pager.endIndex + 1) + " of\n      " + _vm._s(_vm.items.length) + "\n    ")])]), _vm._v(" "), _c('ul', {
    staticClass: "pagination float-right text-xs",
    style: (_vm.ulStyles)
  }, [_c('li', {
    staticClass: "page-item first",
    class: {
      disabled: _vm.pager.currentPage === 1
    },
    style: (_vm.liStyles)
  }, [_c('a', {
    staticClass: "page-link",
    style: (_vm.aStyles),
    on: {
      "click": function($event) {
        return _vm.setPage(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.first))])]), _vm._v(" "), _c('li', {
    staticClass: "page-item previous",
    class: {
      disabled: _vm.pager.currentPage === 1
    },
    style: (_vm.liStyles)
  }, [_c('a', {
    staticClass: "page-link",
    style: (_vm.aStyles),
    on: {
      "click": function($event) {
        return _vm.setPage(_vm.pager.currentPage - 1)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.labels.previous) + "\n      ")])]), _vm._v(" "), _vm._l((_vm.pager.pages), function(page) {
    return _c('li', {
      key: page,
      staticClass: "page-item page-number",
      class: {
        active: _vm.pager.currentPage === page
      },
      style: (_vm.liStyles)
    }, [_c('a', {
      staticClass: "page-link",
      style: (_vm.aStyles),
      on: {
        "click": function($event) {
          return _vm.setPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "page-item next",
    class: {
      disabled: _vm.pager.currentPage === _vm.pager.totalPages
    },
    style: (_vm.liStyles)
  }, [_c('a', {
    staticClass: "page-link",
    style: (_vm.aStyles),
    on: {
      "click": function($event) {
        return _vm.setPage(_vm.pager.currentPage + 1)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.labels.next) + "\n      ")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item last",
    class: {
      disabled: _vm.pager.currentPage === _vm.pager.totalPages
    },
    style: (_vm.liStyles)
  }, [_c('a', {
    staticClass: "page-link",
    style: (_vm.aStyles),
    on: {
      "click": function($event) {
        return _vm.setPage(_vm.pager.totalPages)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.labels.last) + "\n      ")])])], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-35c35301!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/material/components/JwPagination/JwPagination.vue
// module id = 2390
// module chunks = 61